/* eslint-disable no-unused-expressions */
import { BrowserRouter } from 'react-router-dom';
import { CacheProvider } from '@emotion/react';

import { ThemeProvider, CssBaseline } from '@mui/material';
import AppRouter from '../../config/routers';
import createEmotionCache from '../../utils/create-emotion-cache';
import ErrorSnackbar from '../components/common/error-snackbar';

import '../../styles/main.scss';
import { theme } from '../../theme';
import { useEffect } from 'react';

const clientSideEmotionCache = createEmotionCache();

const App = (props: any) => {
  const { emotionCache = clientSideEmotionCache } = props;
  
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const chatbotContainer = document.querySelector(
        ".embedded-agent-container"
      ) as HTMLElement;
      if (chatbotContainer) {
        chatbotContainer.style.bottom = "50px";
      }
  
      const iubendaWidget = document.querySelector(
        ".iub__us-widget"
      ) as HTMLElement;
      if (iubendaWidget) {
        iubendaWidget.style.display = "none";
      }
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
  
    return () => observer.disconnect();
  }, []);

  return (
    <CacheProvider value={emotionCache}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <ErrorSnackbar />
      </ThemeProvider>
    </CacheProvider>
  );
};

export default App;
